/* eslint-disable react-hooks/exhaustive-deps */
// import { initAnalytics } from "hooks/useGCJAnalytics";
import Head from "next/head";
import { PagesContext } from "providers/Pages";
import React, { useEffect, useContext } from "react";

import { useGoogleAdsSettings } from "./useGoogleAdsSettings";
import { useGoogleTagManager } from "./useGoogleTagManager";
import { useGoogleTagServices } from "./useGoogleTagServices";
import { useGoogleTagEvents } from "./useGoogleTagEvents";
import { useUtilsOJC } from "./useUtilsOjc";
import { SessionData } from "providers/Session";
import { parseCookies } from "nookies";

const tagManagerId = process.env.NEXT_PUBLIC_WEBAPP_TAG_MANAGER_ID || "";
const slug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG || "opopular";

const ScriptsProvider: React.FC<any> = ({ children }) => {
  const cookies = parseCookies();
  const sessionData = JSON.parse(cookies.sessionData || "{}") as SessionData;

  //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
  // quando confirmado a migração, remover.
  // useEffect(() => {
  //   initAnalytics(
  //     process.env.NEXT_PUBLIC_SITE_ID_ANALYTICS,
  //     process.env.NEXT_PUBLIC_CONTENTID_ANALYTICS,
  //     sessionData?.emailUsuario
  //   );
  // }, []);

  return (
    <React.Fragment>
      <Head>
        {useGoogleTagManager({ enabled: true, code: tagManagerId, slug })}
        {useGoogleTagServices({ enabled: true })}
        {useGoogleAdsSettings({ enabled: true, slug })}
        {useGoogleTagEvents({ enabled: true })}
        {useUtilsOJC({ enabled: true })}
      </Head>
      {children}
      <script
        key="push-news"
        async
        type="text/javascript"
        src="/scripts/push-news.js"
      />
    </React.Fragment>
  );
};

export default ScriptsProvider;
